import React from 'react';
import { IconProps } from '../types/types';

const BAT: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 134 117" role="img" {...props}><g fill="none"><path d="M67.013.242v45.536l27.252 47.23 39.533 22.965c.356-.622.305-1.48-.24-2.423l-32.281-55.945L68.996 1.66C68.449.714 67.73.242 67.013.242" fill="#9E1F63"/><path d="M.226 115.973 39.76 93.009l27.254-47.231V.242c-.72 0-1.438.472-1.983 1.417L32.748 57.605.465 113.549c-.543.944-.594 1.801-.239 2.424" fill="#FF4724"/><path d="M133.798 115.973 94.265 93.009H39.76L.226 115.973c.358.624 1.126 1.012 2.215 1.012h129.143c1.09 0 1.856-.388 2.214-1.012" fill="#662D91"/><path fill="#FFF" d="M39.76 93.008h54.506l-27.253-47.23z"/></g></svg>
);

export default BAT;
